import { render } from "./ServiceCategoryView.vue?vue&type=template&id=8d00df8c&scoped=true&ts=true"
import script from "./ServiceCategoryView.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryView.vue?vue&type=script&lang=ts"

import "./ServiceCategoryView.vue?vue&type=style&index=0&id=8d00df8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d00df8c"]])

export default __exports__